<template>
  <div class="animated fadeIn">
    <b-form @submit="addOrUpdateGroupRecord">
      <b-row>
        <b-col md="9" sm="12" class="mb-4">
          <h3 v-if="this.group.id" class="card-title mb-0">{{ this.group.id }}</h3>
          <h3 v-if="!this.group.id" class="card-title mb-0">Create New Group</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <!-- Group Form -->
          <GroupForm v-bind:group="group"></GroupForm>
           <b-alert              
              fade
              :show="creategroupFailure"
              :variant="'danger'">
              <span v-html="creategroupFailure">              
              </span>
            </b-alert>
          <b-row align-h="end">
            <b-col cols="auto" class="p-3">
              <b-button variant="link" href="#/dashboard">Cancel</b-button>
              <b-button variant="primary" @click="addOrUpdateGroupRecord">Submit</b-button>
            </b-col>
          </b-row>          
        </b-col>
      </b-row>
    </b-form>
    
    <h2 v-show="createGroupPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
    <pulse-loader :loading="createGroupPending" color="#489AAC" size="50px"></pulse-loader>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GroupForm from '@/views/t1/Admin/GroupForm'

export default {
  name: 'addgroup',
  components: {
    GroupForm
  },
  computed: {
    ...mapGetters({
      group: 'getCreateGroup',
      createdGroup: 'getRecentlyCreatedGroup',
      createGroupPending: 'getCreateGroupPending',
      creategroupFailure: 'getCreategroupFailure'
    })
  },
  watch: {
    createdGroup: function (newValue) {
      if (newValue) {
        this.$router.push({ path: '/admin/groups/' + newValue.id })
      }
    }
  },
  methods: {
    addOrUpdateGroupRecord () {
      this.$validator.validate().then(result => {
        if (result) {
          let group = this.group
          group.groupName = _.trim(group.groupName)
          this.$store.dispatch('createGroup', group)
        }
      })
    }
  },
  beforeDestroy () {
    this.$store.commit('reseetCreateGroup')
  }
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/AddGroup.vue